var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg18(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 321.7 321.7",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st2{fill:#50e530}.st3{fill:#f9820b}.st4{fill:#7ff4f1}.st5{fill:#fff}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.5 213.4s13.4-24.5 19.1-47.6c5.7-23.1 22.6-74 22.6-74L124 120 93.6 222.5s-27.2-4.1-27.1-9.1zM228.1 97.6s28.6 118.7 26.3 120.8c-2.3 2.1-21.9 4.8-21.9 4.8-6.9-7.3-18.8-89-18.8-89l11.3-29.9 3.1-6.7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M139.3 71.2s33.3 15.9 60.8 1.8l28 24.6-14.4 36.6L225 241.3s-77.6 22.6-127.7-3.7l11.6-74.3 30.4-92.1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M139.3 71.2c20.1 6.3 33 6 34.2 6.2 1.3 0 2.6-.1 3.8-.1 1.8.1 6.9-.4 7.7-.6 5.1-.6 10-2.1 15-3.8-4.5 2.8-9.4 4.9-14.7 6-5.2 1.1-10.6 1.5-15.9 1.1-11.7-.7-22.5-4.3-30.1-8.8z",
    fill: "#721212"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M231.7 233.8c-.5 2.4-1.1 3.8-1.6 4.3-2.6 2.4-5.1 3.2-5.1 3.2-4.6-3.3-9.6-6-15-8.2-7.9-3.4-21.9-6.7-36.2-7.1-16.3-.7-33.9 1.3-49.8 4.6-15.8 3.2-26.6 6.9-26.6 6.9-4.9-5.1-2.6-22.8-1.3-29.7 5.7-33.1 12.9-38.7 17.1-60.2 3.1-17.2.6-38.8-4.6-54.8-.2-.7-.3-1-.3-1 .2-.1 31.2-20.8 31-20.7.1.1 1.5 10.1 9.5 16.8 4.8 4 11.9 6.9 22.5 5.7 9.8-1.1 20.4-4.4 25.8-12.7 1.8-2.8 2.5-5.3 2.8-6.7.2-.8.2-1.3.2-1.3.2.2 9.9 8.7 9.6 8.4.4.4 18.3 16.1 18.5 16.2-.2.3-2.3 2.5-4.6 10.9-3.8 12.9-2.8 30.7-.8 44.1 2.3 15.6 13 59.9 8.9 81.3z",
    fill: "#57556d"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M139.6 72.5c.4 1.5 1.1 4 2.5 6.9l-14.5-.4 9.8-6.5h2.2zm70.1 8.9l-12.6-.4c1.8-2.8 2.5-5.3 2.8-6.7l1.7.1 8.1 7z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M227.6 97.1l-118.7-3.5c-.1-.3-.2-.5-.2-.7-.2-.7-.3-1-.3-1l7.3-4.9 33.3 1c4.8 4 11.9 6.9 22.5 5.7 7.1-.8 12.5-2.5 16.5-4.6l31.7.9 7.9 7.1z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M224.5 105.4c-.6 1.9-1.3 4.1-1.9 6.8l-110-3.2c-.5-2.5-.9-4.8-1.4-6.9l113.3 3.3z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M221.4 120.5c-.2 2.1-.3 4.4-.4 6.8l-106.6-3.1c-.1-2.4-.3-4.7-.6-6.8l107.6 3.1z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M221.5 142.4l-107.3-3.1c.2-2.3.3-4.6.3-6.8l106.5 3.1c.2 2.2.3 4.4.5 6.8z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M223.6 157.7l-111.9-3.3c.5-2.1 1.1-4.5 1.5-6.8l109.2 3.2c.3 1.4.6 3.7 1.2 6.9z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M226.5 172.9l-119.8-3.5c1.3-3.6 2.3-6.2 2.5-6.7l116 3.4c.5 2.3.9 4.6 1.3 6.8z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M229.2 188.2l-127.7-3.8c.7-2.2 1.4-4.5 2.2-6.7l124.4 3.7c.3 2.3.7 4.6 1.1 6.8z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M231.4 203.4l-133.7-3.9c.5-2.2.9-4.4 1.5-6.7l131.3 3.9c.3 2.3.6 4.6.9 6.7z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M232.6 218.6l-137.5-4c.2-2.2.5-4.5 1-6.8l136.1 4c.2 2.5.3 4.8.4 6.8z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M232.5 227c-.1 2.8-.5 5.1-.8 6.8l-21.7-.6c-27.6-11.1-62.5-7.3-86-2.5l-29.3-.9c-.2-2-.3-4.3-.2-6.8l138 4z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M107.5 112.4s2 32.2-1.2 41.6c-3.2 9.4-17.1 60.6-22.9 57.9-5.8-2.7-8.5-30.3 5.3-43.3 13.7-13 13.5-54 18.8-56.2z",
    opacity: 0.37,
    fill: "#574f59"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M139.3 71.2c4.7 13.8 14.8 21.4 29.3 20.5 5.6-.2 13.2-1.7 19-4.4 6-2.9 11-7.9 12.5-14.3.2 3.5-1.1 7-3 10-4.1 6.2-10.6 9.4-17.7 11.5-10.7 2.7-22.6 2.7-30.9-4.6-5.7-4.9-8.8-11.9-9.2-18.7z",
    fill: "#d31c1c"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg18);
export default __webpack_public_path__ + "static/media/18.282c41dc9a8f555d1e121877df28e88e.svg";
export { ForwardRef as ReactComponent };